/**
 * PublicRoute - Routing Guard Component
 * Redirects authenticated users away from public pages (e.g. /login)
 * If user is authenticated, they are sent to the dashboard
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { ROUTES } from '@/constants';

export function PublicRoute() {
  const status = useAuthStore((s) => s.status);
  if (status === 'idle' || status === 'loading') {
    return <div className="fixed inset-0 flex items-center justify-center">Cargando…</div>;
  }
  if (status === 'authenticated') return <Navigate to={ROUTES.DASHBOARD} replace />;
  return <Outlet />;
}
